import type { ApiResponse } from '../../shared';

import type { BasicPersonIdentityDto } from '../dto';
import type { BasicPersonIdentity } from '../models';

export const mapBasicPersonIdentityDtoToModel = (
  dto: BasicPersonIdentityDto,
): BasicPersonIdentity => ({ ...dto });

export const mapBasicPersonIdentityApiResponseDtoToModel = (
  dto: ApiResponse<BasicPersonIdentityDto>,
): ApiResponse<BasicPersonIdentity> => ({
  ...dto,
  data: mapBasicPersonIdentityDtoToModel(dto.data),
});
